module.exports = __webpack_public_path__ + "static/media/708.bbc749bc.svg";